import { useParams, Link, Navigate } from "react-router-dom";
import LegalLayout from "@/components/LegalLayout";
import Seo from "@/components/Seo";
import { getPost } from "@/data/blogPosts";
import { CAL_LINK } from "@/lib/booking";
import { blogPostingSchema, breadcrumbSchema } from "@/lib/schema";

export const BlogPost = () => {
  const { slug } = useParams();
  const post = getPost(slug);

  if (!post) return <Navigate to="/blog" replace />;

  const path = `/blog/${slug}`;
  const jsonLd = [
    blogPostingSchema({ title: post.title, description: post.excerpt, path, datePublished: post.date }),
    breadcrumbSchema([
      { name: "Startseite", path: "/" },
      { name: "Blog", path: "/blog" },
      { name: post.title, path },
    ]),
  ];

  return (
    <LegalLayout title={post.title} updated={post.date}>
      <Seo title={`${post.title} – Kurpfalz Automation Blog`} description={post.excerpt} path={path} jsonLd={jsonLd} />
      <div className="space-y-5">
        {post.body.map((paragraph, i) => (
          <p key={i}>{paragraph}</p>
        ))}
      </div>

      <div className="pt-4 flex flex-wrap items-center gap-6">
        <a
          href={CAL_LINK}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center justify-center h-14 px-8 rounded-full bg-[#16273F] hover:bg-[#0E1B2E] text-white text-base font-semibold transition-colors"
        >
          Kostenloses Erstgespräch anfragen
        </a>
        <Link to="/blog" className="text-sm font-semibold text-[#9A8420] hover:text-[#7d6b1a]">
          ← Zurück zum Blog
        </Link>
      </div>
      <p className="pt-1 text-sm text-slate-500">
        Noch keinen Termin?{" "}
        <a href="/#kontakt" className="underline hover:text-[#16273F]">
          Lieber erst kurz schreiben
        </a>
        .
      </p>
    </LegalLayout>
  );
};

export default BlogPost;
